import makeStyles from "@mui/styles/makeStyles";
import { lighten, Theme } from "@mui/material/styles";
import { createStyles } from "@mui/styles";

const useUsersTableRowStyles = makeStyles((theme: Theme) =>
    createStyles({
        showHubsButton: {
            color: theme.palette.text.primary,
            border: `1px solid ${theme.palette.neutrals.dark}`,
            fontSize: 16,
            borderRadius: theme.spacing(1),
            padding: theme.spacing(1.8, 1),
            marginLeft: theme.spacing(1),
            cursor: "pointer",
            whiteSpace: "nowrap",
        },
        activeButton: {
            backgroundColor: theme.palette.neutrals.light,
        },
        expandableRow: {
            "& .MuiTableCell-root": {
                background: theme.palette.background.grey,
                padding: `${theme.spacing(0, 2)} !important`,
                borderBottom: `1px solid ${theme.palette.neutrals.light}`,
            },
            "& .MuiTypography-root": {
                fontSize: 12,
                fontWeight: 600,
            },
        },
        selectedRow: {
            "& .MuiTableCell-root": {
                background: lighten(theme.palette.background.green, 0.4),
            },
        },
        toggleCloseBtn: {
            marginLeft: "auto",
            "& .MuiSvgIcon-root": {
                fontSize: 10,
                color: theme.palette.neutrals.dark,
            },
        },
        tagsBox: {
            display: "flex",
            alignItems: "center",
            lineHeight: 0,
        },
    })
);

export default useUsersTableRowStyles;
